import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import LongTermFlowsTable from "./LongTermFlowsTable";
import btnDownloadIcon from "../../../Assests/download.svg";
import {
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  DISPLAY_LANDED_COST_API,
  DOWNLOAD_LANDED_COST_TABLE_API,
  VIEW_LANDED_COST_TABLE_API,
  HOME_FLOW_DROPDOWN_FILTER_API,
  HOMECARE_GET_TABLE_API,
  NUTRITION_GET_TABLE_API,
  CGO_FLOW_OUTPUT_API,
  CGO_FLOW_OUTPUT2_API,
  CGO_FLOW_OUTPUT_API_DOWNLOAD,
  CGO_FLOW_OUTPUT2_API_DOWNLOAD,
  LONG_FLOW_FACILITY_MASTER_GET_API,
  LONG_FLOW_CASCADE_GET_API,
  LONG_FLOW_PROCUREMENT_GET_API,
  LONG_FLOW_DEMAND_OUTPUT_GET_API,
  LONG_FLOW_PACKAGING_PLANT_GET_API,
  LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API,
  LONG_FLOW_PROCESSING_PLANT_GET_API,
  LONG_FLOW_RM_TRANSPORTATION_GET_API,
  LONG_FLOW_SFG_TRANSPORTATION_GET_API,
  LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API,
  LONG_FLOW_CASCADE_DOWNLOAD_API,
  LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API,
  LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API,
  LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API,
  LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API,
  LONG_FLOW_PROCUREMENT_DOWNLOAD_API,
  LONG_FLOW_RM_TRANSPORTATION_DOWNLOAD_API,
  LONG_FLOW_SFG_TRANSPORTATION_DOWNLOAD_API,
  LONG_FLOW_RMLANDEDCOST_GET_API,
  LONG_FLOW_PMMILANDEDCOST_GET_API,
  LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API,
  LONG_FLOW_PMMILANDEDCOST_DOWNLOAD_API,
  LONG_FLOW_RMPM_PROCUREMENT_GET_API,
  LONG_FLOW_RMPM_TRANSPORTATION_GET_API,
  LONG_FLOW_RMPM_PROCUREMENT_GET_API_MODULE5,
  LONG_FLOW_RM_TRANSPORTATION_GET_API_MODULE5,
  LONG_FLOW_PROCUREMENT_DOWNLOAD_API_MODULE5,
  LONG_FLOW_TRANSPORTATION_DOWNLOAD_API_MODULE5,
  LONG_FLOW_RMLANDEDCOST_GET_API_MODULE4,
  LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API_MODULE4,
} from "../../../Utils/Config";
import { getRequest, postRequest } from "../../../Services/AxiosConfiguration";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../../Redux/Actions/index";

function LongTermFlows(props: any) {
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [rowsData, setRows] = React.useState([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [pageIsLoaded, setPageIsLoaded] = useState<any>(false);
  const [tableColumnsDef, setTableColumnsDef] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key":"factory","value":""},{"key":"line","value":""},{"key":"basepack","value":""},{"key":"time_period","value":""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "basepack", value: "" },
    { key: "time_period", value: "" },
  ]);

  const sortedFactoryNames = factoryOptions.sort((a: any, b: any) =>
    a?.factory_Name.localeCompare(b?.factory_Name),
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  // const selectedTimePeriodData = useSelector(
  //   (state: any) => state.InputDataReducers.selectedTimePeriodData,
  // );

  console.log(selectedFolderData, "selectedFolderData");
  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  console.log(folderModuleName, "folderModuleName");

  const module1Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    {
      displayName: "Procurement output",
      flowTableName: "Procurement output",
    },
    {
      displayName: "RM Transportation",
      flowTableName: "RM Transportation",
    },
    {
      displayName: "Processing Plant",
      flowTableName: "Processing Plant",
    },
    {
      displayName: "SFG Transportation",
      flowTableName: "SFG Transportation",
    },
    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  const module2Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    {
      displayName: "RM Landed Cost output",
      flowTableName: "RM Landed Cost output",
    },
    {
      displayName: "PMMI Landed Cost output",
      flowTableName: "PMMI Landed Cost output",
    },
    {
      displayName: "Processing Plant",
      flowTableName: "Processing Plant",
    },
    {
      displayName: "SFG Transportation",
      flowTableName: "SFG Transportation",
    },
    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  const module3Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    {
      displayName: "RMPM Procurement output",
      flowTableName: "RMPM Procurement output",
    },
    {
      displayName: "RMPM Transportation output",
      flowTableName: "RMPM Transportation output",
    },
    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  const module4Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    {
      displayName: "RM Landed Cost output",
      flowTableName: "RM Landed Cost output",
    },

    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  const module5Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    // {
    //   displayName: "RM Landed Cost output",
    //   flowTableName: "RM Landed Cost output"
    // },
    {
      displayName: "RMPM Procurement output",
      flowTableName: "RMPM Procurement output",
    },
    {
      displayName: "RMPM Transportation output",
      flowTableName: "RMPM Transportation output",
    },
    {
      displayName: "Processing Plant",
      flowTableName: "Processing Plant",
    },
    {
      displayName: "SFG Transportation",
      flowTableName: "SFG Transportation",
    },
    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  const module6Options = [
    {
      displayName: "Facility Master output",
      flowTableName: "Facility Master output",
    },
    {
      displayName: "Cascade Master output",
      flowTableName: "Cascade Master output",
    },
    {
      displayName: "RM Landed Cost output",
      flowTableName: "RM Landed Cost output",
    },
    {
      displayName: "Processing Plant",
      flowTableName: "Processing Plant",
    },
    {
      displayName: "SFG Transportation",
      flowTableName: "SFG Transportation",
    },
    {
      displayName: "Packaging Plant",
      flowTableName: "Packaging Plant",
    },
    {
      displayName: "Primary Transportation",
      flowTableName: "Primary Transportation",
    },
    {
      displayName: "Demand Output",
      flowTableName: "Demand Output",
    },
  ];

  //flow dropdown filter options
  const [filterDropdownOptions, setFilterDropdownOptions] =
    useState<any>(module1Options);

  useEffect(() => {
    if (folderModuleName === "module2") {
      setFilterDropdownOptions(module2Options);
      setSelectFlowFilterOption(module2Options[0]);
    } else if (folderModuleName === "module3") {
      setFilterDropdownOptions(module3Options);
      setSelectFlowFilterOption(module3Options[0]);
    } else if (folderModuleName === "module4") {
      setFilterDropdownOptions(module4Options);
      setSelectFlowFilterOption(module4Options[0]);
    } else if (folderModuleName === "module5") {
      setFilterDropdownOptions(module5Options);
      setSelectFlowFilterOption(module5Options[0]);
    } else if (folderModuleName === "module6") {
      setFilterDropdownOptions(module6Options);
      setSelectFlowFilterOption(module6Options[0]);
    } else {
      setFilterDropdownOptions(module1Options);
    }
  }, [folderModuleName]);

  console.log(filterDropdownOptions, folderModuleName, "filterDropdownOptions");
  const [selectFlowFilterOption, setSelectFlowFilterOption] = useState<any>({
    displayName: "Facility Master output",
    flowTableName: "Facility Master output",
  });
  const [pritransportationalco2Data, setPritransportationalco2Data] =
    useState<any>([]);

  var base = 0;
  var time = 0;

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  if (selectedFolderId) {
    console.log("selectedScenarioId", selectedScenarioId);
  }

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  if (selectedUsecaseId) {
    console.log("InputData Modal selectedUsecaseId: ", selectedUsecaseId);
  }

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
      setPageIsLoaded(true);
    } else {
      setPageIsLoaded(false);
    }
  }, []);

  useEffect(() => {
    console.log(selectFlowFilterOption, "selectFlowFilterOption");
    console.log(folderModuleName, "folderModuleNamefolderModuleName");
    if (folderModuleName === "module2") {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT_Module2",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    } else if (folderModuleName === "module3") {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT_Module3",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    } else if (folderModuleName === "module4") {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT_Module4",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    } else if (folderModuleName === "module5") {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT_Module5",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    } else if (folderModuleName === "module6") {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT_Module6",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    } else {
      callTableGridApi(
        "",
        "dropdown",
        "flow_facilitymaster_LT",
        LONG_FLOW_FACILITY_MASTER_GET_API,
      );
    }
  }, [folderModuleName]);

  useEffect(() => {
    handleChangeSelectFlowFilterGeneric(
      { target: { value: selectFlowFilterOption } },
      folderModuleName === "module1"
        ? 1
        : folderModuleName === "module2"
          ? 2
          : folderModuleName === "module3"
            ? 3
            : folderModuleName === "module4"
              ? 4
              : folderModuleName === "module5"
                ? 5
                : folderModuleName === "module6"
                  ? 6
                  : undefined,
    );
  }, [selectedTimePeriodData]);

  const handleChangeSelectFlowFilterGeneric = (
    event: any,
    moduleNum?: number,
  ) => {
    let tableName = `flow_facilitymaster_LT${moduleNum ? `_Module${moduleNum}` : ""}`;
    let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
    const {
      target: { value },
    } = event;
    setSelectFlowFilterOption(value);

    const displayNameMap: any = {
      "Cascade Master output": {
        table: `flow_cascademaster_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_CASCADE_GET_API,
      },
      "Procurement output": {
        table: `flow_rmpmmiprocurement_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_PROCUREMENT_GET_API,
      },
      "RM Landed Cost output": {
        table: `flow_rmlandedcost_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_RMLANDEDCOST_GET_API,
      },
      "PMMI Landed Cost output": {
        table: `flow_pmmilandedcost_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_PMMILANDEDCOST_GET_API,
      },
      "RMPM Procurement output": {
        table: `flow_rmpmprocurement_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_RMPM_PROCUREMENT_GET_API,
      },
      "RMPM Transportation output": {
        table: `flow_rmpmtransportation_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_RMPM_TRANSPORTATION_GET_API,
      },
      "RM Transportation": {
        table: `flow_rmpmmitransportation_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_RM_TRANSPORTATION_GET_API,
      },
      "Processing Plant": {
        table: `flow_processingplant_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_PROCESSING_PLANT_GET_API,
      },
      "SFG Transportation": {
        table: `flow_sfgtransportation_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_SFG_TRANSPORTATION_GET_API,
      },
      "Packaging Plant": {
        table: `flow_packagingplant_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_PACKAGING_PLANT_GET_API,
      },
      "Primary Transportation": {
        table: `flow_primarytransportation_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API,
      },
      "Demand Output": {
        table: `flow_demand_LT${moduleNum ? `_Module${moduleNum}` : ""}`,
        api: LONG_FLOW_DEMAND_OUTPUT_GET_API,
      },
    };

    if (displayNameMap[value.displayName]) {
      tableName = displayNameMap[value.displayName].table;
      urlapi = displayNameMap[value.displayName].api;
    }

    callTableGridApi(value, "dropdown", tableName, urlapi);
  };
  // const handleChangeSelectFlowFilter = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "Procurement output") {
  //     tableName = "flow_rmpmmiprocurement_LT";
  //     urlapi = LONG_FLOW_PROCUREMENT_GET_API;
  //   } else if (value.displayName === "RM Transportation") {
  //     tableName = "flow_rmpmmitransportation_LT";
  //     urlapi = LONG_FLOW_RM_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Processing Plant") {
  //     tableName = "flow_processingplant_LT";
  //     urlapi = LONG_FLOW_PROCESSING_PLANT_GET_API;
  //   } else if (value.displayName === "SFG Transportation") {
  //     tableName = "flow_sfgtransportation_LT";
  //     urlapi = LONG_FLOW_SFG_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   } else {
  //     tableName = "flow_facilitymaster_LT";
  //     urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  // const handleChangeSelectFlowFilter2 = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT_Module2";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT_Module2";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "RM Landed Cost output") {
  //     tableName = "flow_rmlandedcost_LT_Module2";
  //     urlapi = LONG_FLOW_RMLANDEDCOST_GET_API;
  //   } else if (value.displayName === "PMMI Landed Cost output") {
  //     tableName = "flow_pmmilandedcost_LT_Module2";
  //     urlapi = LONG_FLOW_PMMILANDEDCOST_GET_API;
  //   } else if (value.displayName === "Processing Plant") {
  //     tableName = "flow_processingplant_LT_Module2";
  //     urlapi = LONG_FLOW_PROCESSING_PLANT_GET_API;
  //   } else if (value.displayName === "SFG Transportation") {
  //     tableName = "flow_sfgtransportation_LT_Module2";
  //     urlapi = LONG_FLOW_SFG_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT_Module2";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT_Module2";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT_Module2";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   } else {
  //     tableName = "flow_facilitymaster_LT_Module2";
  //     urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  // const handleChangeSelectFlowFilter3 = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT_Module3";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT_Module3";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "RMPM Procurement output") {
  //     tableName = "flow_rmpmprocurement_LT_Module3";
  //     urlapi = LONG_FLOW_RMPM_PROCUREMENT_GET_API;
  //   } else if (value.displayName === "RMPM Transportation output") {
  //     tableName = "flow_rmpmtransportation_LT_Module3";
  //     urlapi = LONG_FLOW_RMPM_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT_Module3";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT_Module3";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT_Module3";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  // const handleChangeSelectFlowFilter4 = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT_Module4";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT_Module4";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "RM Landed Cost output") {
  //     tableName = "flow_rmlandedcost_LT_Module4";
  //     urlapi = LONG_FLOW_RMLANDEDCOST_GET_API_MODULE4;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT_Module4";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT_Module4";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT_Module4";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   } else {
  //     tableName = "flow_facilitymaster_LT_Module4";
  //     urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  // const handleChangeSelectFlowFilter5 = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT_Module5";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT_Module5";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "RM Landed Cost output") {
  //     tableName = "flow_rmlandedcost_LT_Module5";
  //     urlapi = LONG_FLOW_PROCUREMENT_GET_API;
  //   } else if (value.displayName === "RMPM Procurement output") {
  //     tableName = "flow_rmpmprocurement_LT_Module5";
  //     urlapi = LONG_FLOW_RMPM_PROCUREMENT_GET_API_MODULE5;
  //   } else if (value.displayName === "RMPM Transportation output") {
  //     tableName = "flow_rmpmtransportation_LT_Module5";
  //     urlapi = LONG_FLOW_RM_TRANSPORTATION_GET_API_MODULE5;
  //   } else if (value.displayName === "Processing Plant") {
  //     tableName = "flow_processingplant_LT_Module5";
  //     urlapi = LONG_FLOW_PROCESSING_PLANT_GET_API;
  //   } else if (value.displayName === "SFG Transportation") {
  //     tableName = "flow_sfgtransportation_LT_Module5";
  //     urlapi = LONG_FLOW_SFG_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT_Module5";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT_Module5";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT_Module5";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   } else {
  //     tableName = "flow_facilitymaster_LT_Module5";
  //     urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  // const handleChangeSelectFlowFilter6 = (event: any) => {
  //   let tableName = "flow_facilitymaster_LT";
  //   let urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectFlowFilterOption(value);
  //   if (value.displayName === "Cascade Master output") {
  //     tableName = "flow_cascademaster_LT_Module6";
  //     urlapi = LONG_FLOW_CASCADE_GET_API;
  //   } else if (value.displayName === "RM Landed Cost output") {
  //     tableName = "flow_rmlandedcost_LT_Module6";
  //     urlapi = LONG_FLOW_RMLANDEDCOST_GET_API;
  //   } else if (value.displayName === "Processing Plant") {
  //     tableName = "flow_processingplant_LT_Module6";
  //     urlapi = LONG_FLOW_PROCESSING_PLANT_GET_API;
  //   } else if (value.displayName === "SFG Transportation") {
  //     tableName = "flow_sfgtransportation_LT_Module6";
  //     urlapi = LONG_FLOW_SFG_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Packaging Plant") {
  //     tableName = "flow_packagingplant_LT_Module6";
  //     urlapi = LONG_FLOW_PACKAGING_PLANT_GET_API;
  //   } else if (value.displayName === "Primary Transportation") {
  //     tableName = "flow_primarytransportation_LT_Module6";
  //     urlapi = LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API;
  //   } else if (value.displayName === "Demand Output") {
  //     tableName = "flow_demand_LT_Module6";
  //     urlapi = LONG_FLOW_DEMAND_OUTPUT_GET_API;
  //   } else {
  //     tableName = "flow_facilitymaster_LT_Module6";
  //     urlapi = LONG_FLOW_FACILITY_MASTER_GET_API;
  //   }
  //   callTableGridApi(value, "dropdown", tableName, urlapi);
  // };

  function toCamelCase(inputString: string) {
    return inputString.replace(/\w\S*/g, function (txt) {
      return txt
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    });
  }

  function Upper(str: any) {
    let strC;

    switch (str) {
      case "Rm Pm Mi Type":
        let endStr1: any = "Type";
        var strR = str.replace(endStr1, "").toUpperCase();
        strC = strR + endStr1;
        return strC;

      case "Rm Pm Mi Code":
        let endStr2: any = "Code";
        var strR = str.replace(endStr2, "").toUpperCase();
        strC = strR + endStr2;
        return strC;

      case "Rm Pm Mi Description":
        let endStr3: any = "Description";
        var strR = str.replace(endStr3, "").toUpperCase();
        strC = strR + endStr3;
        return strC;

      case "Cpt":
        strC = str.toUpperCase();
        return strC;

      case "Co2":
        strC = str.toUpperCase();
        return strC;

      case "Sfg Code":
        let endStr6: any = "Code";
        var strR = str.replace(endStr6, "").toUpperCase();
        strC = strR + endStr6;
        return strC;

      case "Sfg Description":
        let endStr7: any = "Description";
        var strR = str.replace(endStr7, "").toUpperCase();
        strC = strR + endStr7;
        return strC;

      case "Fg Code":
        let endStr8: any = "Code";
        var strR = str.replace(endStr8, "").toUpperCase();
        strC = strR + endStr8;
        return strC;

      case "Sfg Pm Code":
        let endStr9: any = "Code";
        var strR = str.replace(endStr9, "").toUpperCase();
        strC = strR + endStr9;
        return strC;

      case "Rm Pm Code":
        let endStr10: any = "Code";
        var strR = str.replace(endStr10, "").toUpperCase();
        strC = strR + endStr10;
        return strC;

      case "Rm Pm Description":
        let endStr11: any = "Description";
        var strR = str.replace(endStr11, "").toUpperCase();
        strC = strR + endStr11;
        return strC;

      case "Rm Landed Cost":
        let endStr12: any = "Landed Cost";
        var strR = str.replace(endStr12, "").toUpperCase();
        strC = strR + endStr12;
        return strC;

      case "Mipm Landed Cost":
        let endStr13: any = "Landed Cost";
        var strR = str.replace(endStr13, "").toUpperCase();
        strC = strR + endStr13;
        return strC;

      default:
        return strC;
    }
  }

  const callTableGridApi = (
    value?: any,
    type?: string,
    tableName?: any,
    urlapi?: any,
  ) => {
    setTableColumnsDef([]);
    console.log(tableName, urlapi, "tableName");
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      Time_period:
        selectedTimePeriodData && Array.isArray(selectedTimePeriodData)
          ? selectedTimePeriodData.join(",")
          : selectedTimePeriodData,
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapi;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, type, "responseData");
          if (type === "dropdown") {
            setIsProcessed(true);

            const filteredData =
              Array.isArray(selectedTimePeriodData) &&
              selectedTimePeriodData.length
                ? response.data.filter((row: any) =>
                    selectedTimePeriodData.includes(row.time_Period),
                  )
                : response.data;
            setRows(filteredData);

            const columns: any = [];
            if (response.data) {
              Object.keys(response.data[0]).map((col) => {
                if (
                  col !== "scenario_id" &&
                  col !== "folder_Id" &&
                  col.toLowerCase() !== "id"
                ) {
                  columns.push({
                    id: col,
                    label:
                      toCamelCase(col) == "Rm Pm Mi Type" ||
                      toCamelCase(col) == "Rm Pm Mi Code" ||
                      toCamelCase(col) == "Rm Pm Mi Description" ||
                      toCamelCase(col) == "Cpt" ||
                      toCamelCase(col) == "Co2" ||
                      toCamelCase(col) == "Sfg Code" ||
                      toCamelCase(col) == "Sfg Description" ||
                      toCamelCase(col) == "Fg Code" ||
                      toCamelCase(col) == "Sfg Pm Code" ||
                      toCamelCase(col) == "Rm Pm Code" ||
                      toCamelCase(col) == "Rm Pm Description" ||
                      toCamelCase(col) == "Rm Landed Cost" ||
                      toCamelCase(col) == "Mipm Landed Cost"
                        ? Upper(toCamelCase(col))
                        : toCamelCase(col),
                    minWidth: 100,
                    fontWeight: 600,
                  });
                }
              });
            }
            console.log(columns, "columnsssssss");
            if (columns.length > 0) {
              setTableColumnsDef(columns);
            }
          } else {
            // axios({ url: API_BASE_URL + apiUrl, method: 'post', responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json;' }, data: requestParam }).then((response) => {
            //   let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            //   FileSaver(blob, "Optimized Output" + '.xlsx');
            // });
          }
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const callTableGridApiDownload = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "Procurement output") {
      tableName = "flow_rmpmmiprocurement_LT";
      urlapiDownload = LONG_FLOW_PROCUREMENT_DOWNLOAD_API;
    } else if (value.displayName === "Procurement output") {
      tableName = "flow_rmpmmiprocurement_LT";
      urlapiDownload = LONG_FLOW_PROCUREMENT_DOWNLOAD_API;
    } else if (value.displayName === "RM Transportation") {
      tableName = "flow_rmpmmitransportation_LT";
      urlapiDownload = LONG_FLOW_RM_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Processing Plant") {
      tableName = "flow_processingplant_LT";
      urlapiDownload = LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "SFG Transportation") {
      tableName = "flow_sfgtransportation_LT";
      urlapiDownload = LONG_FLOW_SFG_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const callTableGridApiDownload2 = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT_Module2";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT_Module2";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "RM Landed Cost output") {
      tableName = "flow_rmlandedcost_LT_Module2";
      urlapiDownload = LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API;
    } else if (value.displayName === "PMMI Landed Cost output") {
      tableName = "flow_pmmilandedcost_LT_Module2";
      urlapiDownload = LONG_FLOW_PMMILANDEDCOST_DOWNLOAD_API;
    } else if (value.displayName === "Processing Plant") {
      tableName = "flow_processingplant_LT_Module2";
      urlapiDownload = LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "SFG Transportation") {
      tableName = "flow_sfgtransportation_LT_Module2";
      urlapiDownload = LONG_FLOW_SFG_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT_Module2";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT_Module2";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT_Module2";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT_Module2";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const callTableGridApiDownload3 = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT_Module3";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT_Module3";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "RMPM Procurement output") {
      tableName = "flow_rmpmprocurement_LT_Module3";
      urlapiDownload = LONG_FLOW_PROCUREMENT_DOWNLOAD_API;
    } else if (value.displayName === "RMPM Transportation output") {
      tableName = "flow_rmpmtransportation_LT_Module3";
      urlapiDownload = LONG_FLOW_RM_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT_Module3";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT_Module3";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT_Module3";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT_Module3";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const callTableGridApiDownload4 = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT_Module4";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT_Module4";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "RM Landed Cost output") {
      tableName = "flow_rmpmprocurement_LT_Module4";
      urlapiDownload = LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API_MODULE4;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT_Module4";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT_Module4";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT_Module4";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT_Module4";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const callTableGridApiDownload5 = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT_Module5";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT_Module5";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "RM Landed Cost output") {
      tableName = "flow_rmlandedcost_LT_Module5";
      urlapiDownload = LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API;
    } else if (value.displayName === "RMPM Procurement output") {
      tableName = "flow_rmpmprocurement_LT_Module5";
      urlapiDownload = LONG_FLOW_PROCUREMENT_DOWNLOAD_API_MODULE5;
    } else if (value.displayName === "RMPM Transportation output") {
      tableName = "flow_rmpmtransportation_LT_Module5";
      urlapiDownload = LONG_FLOW_TRANSPORTATION_DOWNLOAD_API_MODULE5;
    } else if (value.displayName === "Processing Plant") {
      tableName = "flow_processingplant_LT_Module5";
      urlapiDownload = LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT_Module5";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT_Module5";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT_Module5";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT_Module5";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const callTableGridApiDownload6 = (value?: any, type?: string) => {
    var tableName = "flow_facilitymaster_LT_Module6";
    var urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    if (value.displayName === "Cascade Master output") {
      tableName = "flow_cascademaster_LT_Module6";
      urlapiDownload = LONG_FLOW_CASCADE_DOWNLOAD_API;
    } else if (value.displayName === "RM Landed Cost output") {
      tableName = "flow_rmlandedcost_LT_Module6";
      urlapiDownload = LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API;
    } else if (value.displayName === "Processing Plant") {
      tableName = "flow_processingplant_LT_Module6";
      urlapiDownload = LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "SFG Transportation") {
      tableName = "flow_sfgtransportation_LT_Module6";
      urlapiDownload = LONG_FLOW_SFG_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Packaging Plant") {
      tableName = "flow_packagingplant_LT_Module6";
      urlapiDownload = LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API;
    } else if (value.displayName === "Primary Transportation") {
      tableName = "flow_primarytransportation_LT_Module6";
      urlapiDownload = LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API;
    } else if (value.displayName === "Demand Output") {
      tableName = "flow_demand_LT_Module6";
      urlapiDownload = LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API;
    } else {
      tableName = "flow_facilitymaster_LT_Module6";
      urlapiDownload = LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API;
    }
    console.log("value.....", value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: [],
    };

    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = urlapiDownload;
    postRequest(API_BASE_URL + apiUrl, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          axios({
            url: API_BASE_URL + apiUrl,
            method: "post",
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver(blob, "Optimized Output" + ".xlsx");
          });
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    const requestParam = {
      usecase_id: selectedUsecaseId,
      category_id: selectedCategoryId,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + HOME_FLOW_DROPDOWN_FILTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, requestParam, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log("responsedata", response.data);
          // setFilterDropdownOptions(response.data);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  }, [selectedUsecaseId, selectedCategoryId]);

  const handleDownload = (e: any) => {
    if (folderModuleName === "module2") {
      callTableGridApiDownload2(selectFlowFilterOption, "download");
    } else if (folderModuleName === "module3") {
      callTableGridApiDownload3(selectFlowFilterOption, "download");
    } else if (folderModuleName === "module4") {
      callTableGridApiDownload4(selectFlowFilterOption, "download");
    } else if (folderModuleName === "module5") {
      callTableGridApiDownload5(selectFlowFilterOption, "download");
    } else if (folderModuleName === "module6") {
      callTableGridApiDownload6(selectFlowFilterOption, "download");
    } else {
      callTableGridApiDownload(selectFlowFilterOption, "download");
    }
  };

  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    // console.log("Time Period Join_______________________________________", timePeriodValues)
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId === 0 ?"tblLandedCost" : "tblScenario_LandedCost", "time_period": "", "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: scenarioId === 0 ? "tblLandedCost" : "tblScenario_LandedCost",
      time_period: "",
      filter: filterList,
    };
    const urls = API_BASE_URL + DOWNLOAD_LANDED_COST_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  return (
    <>
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Flows</h3>
          </div>
          <div className="filters">
            {/* <RestoreOutlinedIcon className="restoreIcon" onClick={(e) => handleRestoreClicked(e)}/> */}

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Select Flow</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectFlowFilterOption}
                  placeholder="Select Flows"
                  onChange={
                    folderModuleName === "module2"
                      ? (e) => handleChangeSelectFlowFilterGeneric(e, 2)
                      : folderModuleName === "module3"
                        ? (e) => handleChangeSelectFlowFilterGeneric(e, 3)
                        : folderModuleName === "module4"
                          ? (e) => handleChangeSelectFlowFilterGeneric(e, 4)
                          : folderModuleName === "module5"
                            ? (e) => handleChangeSelectFlowFilterGeneric(e, 5)
                            : folderModuleName === "module6"
                              ? (e) => handleChangeSelectFlowFilterGeneric(e, 6)
                              : (e) => handleChangeSelectFlowFilterGeneric(e)
                  }
                  renderValue={(selectFlowFilterOption: any) =>
                    selectFlowFilterOption?.displayName
                  }
                  className="select-short-term"
                >
                  {filterDropdownOptions.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d} style={{ fontSize: "15px" }}>
                        {d.displayName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <div className="content-download-btn" onClick={handleDownload}>
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <LongTermFlowsTable
          isProcessed={isProcessed}
          rowsData={rowsData}
          columns={tableColumnsDef}
        />
      </div>
    </>
  );
}

export default LongTermFlows;
